import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Icon } from '../..';
import { ICON_LINK_DEFAULT_MODE, ICON_LINK_DEFAULT_SCHEMA, ICON_LINK_DEFAULT_SIZE, ICON_LINK_DEFAULT_VARIANT, ICON_LINK_ICON_SIZES } from './IconLink.constants';
import { IconLinkRoot } from './IconLink.styled';
// Component.
// -----------------------------------------------------------------------------
const IconLink = forwardRef(({ href, icon, mode = ICON_LINK_DEFAULT_MODE, schema = ICON_LINK_DEFAULT_SCHEMA, size = ICON_LINK_DEFAULT_SIZE, variant = ICON_LINK_DEFAULT_VARIANT, ...rest }, ref) => {
    return (_jsx(IconLinkRoot, { href: href, mode: mode, ref: ref, schema: schema, size: size, variant: variant, title: rest.title || rest['aria-label'], ...rest, children: _jsx(Icon, { icon: icon, size: ICON_LINK_ICON_SIZES[size], title: rest.title || rest['aria-label'] }) }));
});
// Component configuration.
// -----------------------------------------------------------------------------
IconLink.displayName = 'IconLink';
export default IconLink;
//# sourceMappingURL=IconLink.js.map